import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Shift } from '../entities/shift';

@Injectable()
export class ShiftService extends BaseCrudService<Shift> {

  public uri = '/api/shift/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ShiftService');
  }

  buildSentence(entity?: Shift, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.entryHour ?
          `entryHour${QueryOperator.Equal}${entity.entryHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.exitHour ?
          `exitHour${QueryOperator.Equal}${entity.exitHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.entryToleranceHour ?
          `entryToleranceHour${QueryOperator.Equal}${entity.entryToleranceHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.exitToleranceHour ?
          `exitToleranceHour${QueryOperator.Equal}${entity.exitToleranceHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.startLunchHour ?
          `startLunchHour${QueryOperator.Equal}${entity.startLunchHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.endLunchHour ?
          `endLunchHour${QueryOperator.Equal}${entity.endLunchHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.weekendStartHour ?
          `weekendStartHour${QueryOperator.Equal}${entity.weekendStartHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.weekendEndHour ?
          `weekendEndHour${QueryOperator.Equal}${entity.weekendEndHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day1 ?
          `day1${QueryOperator.Equal}${entity.day1}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day2 ?
          `day2${QueryOperator.Equal}${entity.day2}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day3 ?
          `day3${QueryOperator.Equal}${entity.day3}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day4 ?
          `day4${QueryOperator.Equal}${entity.day4}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day5 ?
          `day5${QueryOperator.Equal}${entity.day5}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day6 ?
          `day6${QueryOperator.Equal}${entity.day6}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.day7 ?
          `day7${QueryOperator.Equal}${entity.day7}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.holiday ?
          `holiday${QueryOperator.Equal}${entity.holiday}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/shift.service.ts